import React, { useContext } from 'react';
import classNames from 'classnames';
import './page.module.scss';
import { BackButton } from '../../../../commonv3/components/atoms/buttons/BackButton';
import { ApplicationPageContext, ApplicationPageHeaderType } from '../../../contexts/applicaitonPageContext';
import { ApplicationPaneHeader } from './ApplicationPaneHeader';

type PageProps = {
    id?: string;
    children: React.ReactNode;
    className?: string;
    styleName?: string;
};

export const Page = ({ children, id = undefined, className = undefined }: PageProps) => (
    <div styleName="page" className={className} id={id}>
        {children}
    </div>
);
export const Pane = ({ children, id = undefined, className = undefined }: PageProps) => (
    <div styleName="pane" className={className} id={id}>
        {children}
    </div>
);
export const PaneHeader = ({ children }) => <div styleName="pane-header">{children}</div>;
export const PaneBody = ({ children }) => <div styleName={'pane-body'}>{children}</div>;
export const StepIndicator = ({ children }) => <div styleName={'step-indicator'}>{children}</div>;
export const Step = ({ children, active }) => <div styleName={classNames('step', { active: active })}>{children}</div>;
export const PaneBackButton = () => <BackButton styleName="back-button" />;

/**
 * 申込ページ内の各パネルのヘッダー
 * ApplicationPageContextの設定に応じて
 * - プラン名を出す
 * - 指定されたヘッダーを出す
 * の2パターンを切り替えする
 */
export const ContextAwarePaneHeader = ({ children, planName }) => {
    const context = useContext(ApplicationPageContext);
    switch (context.headerType) {
        case ApplicationPageHeaderType.PAGE_NAME:
            return <ApplicationPaneHeader plan={planName} />;
        case ApplicationPageHeaderType.TEXT:
            return <PaneHeader>{children}</PaneHeader>;
        default:
            return null;
    }
};
